import { useSkin } from '@hooks/useSkin'

const useLogo = () => {
    const [skin, setSkin] = useSkin()
    return require(`@src/assets/images/logo/${skin === 'dark' ? 'custom-white-logo.svg' : 'tip-color-logo.svg'}`).default
}

export default {
    useLogo
}